import { render, staticRenderFns } from "./EcommerceOrderChart.vue?vue&type=template&id=501f6fae"
import script from "./EcommerceOrderChart.vue?vue&type=script&lang=js"
export * from "./EcommerceOrderChart.vue?vue&type=script&lang=js"
import style0 from "./EcommerceOrderChart.vue?vue&type=style&index=0&id=501f6fae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports